import styled from "styled-components";

const ImageSmallRoot = styled.div`
  height: 120px;
`;

export default ImageSmallRoot;
